import { SvgIcon } from '@material-ui/core'

export default function ChevronLeftIcon(props) {
  return (
    <SvgIcon {...props} fill="none">
      <path
        d="M15 18L9 12L15 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
